// Fictional company "Lozhka", a food-delivery app. Release day for version 4.2.
// See README.md for the schema.
export default {
  id: 'qa-engineer',
  occupationId: '683b01059a1e027695ece8a0',
  occupationName: { en: 'QA engineer', ua: 'Тестувальник' },
  format: 'studio',
  title: { en: 'A day as a QA engineer', ua: 'День тестувальника' },
  tagline: {
    en: 'Release day, 200 tests, five open bugs and a developer who says it works on his machine',
    ua: 'День релізу, 200 тестів, п’ять відкритих багів і розробник, у якого «все працює»'
  },
  minutes: 10,
  intro: {
    en: 'You test the "Lozhka" food-delivery app at a 30-person product team. Version 4.2 with a new sign-up flow and courier tracking goes to the store tonight. The automated run has just finished, manual regression is half done, and marketing has already scheduled the launch post.',
    ua: 'Ти тестуєш застосунок доставки їжі «Ложка» в продуктовій команді на 30 людей. Версія 4.2 із новою реєстрацією та трекінгом кур’єра сьогодні ввечері йде в стор. Автоматичний прогін щойно завершився, ручна регресія пройдена наполовину, а маркетинг уже запланував пост про запуск.'
  },
  goal: {
    en: 'Ship a release you would put your name on, without becoming the person who blocks everything',
    ua: 'Випустити реліз, під яким поставиш своє ім’я, і не стати тим, хто блокує все'
  },
  kpis: [
    { key: 'quality', label: { en: 'Release quality', ua: 'Якість релізу' }, start: 60 },
    { key: 'coverage', label: { en: 'Coverage', ua: 'Покриття' }, start: 55 },
    { key: 'team', label: { en: 'Team trust', ua: 'Довіра команди' }, start: 65 }
  ],
  competencies: [
    {
      key: 'attention',
      label: { en: 'Attention to detail', ua: 'Уважність до деталей' },
      skill: { _id: '686282c1aa8e5a92e3bc1408', name: 'Точність' }
    },
    {
      key: 'risk',
      label: { en: 'Risk assessment', ua: 'Оцінка ризиків' },
      skill: { _id: '686282c1aa8e5a92e3bc136d', name: 'Управління ризиками' }
    },
    {
      key: 'communication',
      label: { en: 'Communication', ua: 'Комунікація' },
      skill: { _id: '686282c1aa8e5a92e3bc133c', name: 'Комунікативність' }
    },
    {
      key: 'process',
      label: { en: 'Process', ua: 'Процес' },
      skill: { _id: '686282c1aa8e5a92e3bc1403', name: 'Забезпечення якості' }
    },
    {
      key: 'analysis',
      label: { en: 'Analysis', ua: 'Аналіз' },
      skill: { _id: '686282c1aa8e5a92e3bc1364', name: 'Аналітичне мислення' }
    }
  ],
  people: [
    {
      key: 'dev',
      name: { en: 'Maksym', ua: 'Максим' },
      role: { en: 'Mobile developer', ua: 'Мобільний розробник' },
      initials: 'MK',
      color: '#30b0c7'
    },
    {
      key: 'pm',
      name: { en: 'Kateryna', ua: 'Катерина' },
      role: { en: 'Product manager', ua: 'Продакт-менеджерка' },
      initials: 'KA',
      color: '#d5921b'
    },
    {
      key: 'lead',
      name: { en: 'Oksana', ua: 'Оксана' },
      role: { en: 'Release manager', ua: 'Реліз-менеджерка' },
      initials: 'OK',
      color: '#9c27b0'
    },
    {
      key: 'support',
      name: { en: 'Yurii', ua: 'Юрій' },
      role: { en: 'Support lead', ua: 'Керівник підтримки' },
      initials: 'YU',
      color: '#19857b'
    },
    {
      key: 'junior',
      name: { en: 'Sofiia', ua: 'Софія' },
      role: { en: 'Junior QA', ua: 'Джуніор-тестувальниця' },
      initials: 'SO',
      color: '#e25510'
    }
  ],
  steps: [
    {
      type: 'spot',
      id: 's1',
      at: '09:00',
      comp: ['attention', 'analysis'],
      traits: ['C', 'I'],
      text: {
        en: 'Release 4.2 goes to the store tonight. The new sign-up screen below has 3 bugs. Tap each one.',
        ua: 'Реліз 4.2 сьогодні ввечері йде в стор. На новому екрані реєстрації нижче 3 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'form',
        title: { en: 'Create account — build 4.2.118', ua: 'Створити акаунт — збірка 4.2.118' },
        blocks: [
          { id: 'b1', kind: 'heading', label: { en: 'Sign up', ua: 'Реєстрація' }, value: '' },
          { id: 'b2', kind: 'field', label: { en: 'Name', ua: 'Ім’я' }, value: 'Oleh Petrenko' },
          {
            id: 'b3',
            kind: 'field',
            label: { en: 'Phone', ua: 'Телефон' },
            value: '+380 97 12A 45 6B',
            issue: {
              en: 'The phone field accepts letters. It needs a digits-only mask.',
              ua: 'Поле телефону приймає літери. Потрібна маска лише з цифр.'
            }
          },
          {
            id: 'b4',
            kind: 'field',
            label: { en: 'Email', ua: 'Email' },
            value: 'oleh.petrenko@mail.example'
          },
          {
            id: 'b5',
            kind: 'field',
            label: { en: 'Password', ua: 'Пароль' },
            value: 'Qwerty123',
            issue: {
              en: 'The password is shown in plain text. It must be masked by default.',
              ua: 'Пароль показано відкритим текстом. За замовчуванням він має бути прихований.'
            }
          },
          {
            id: 'b6',
            kind: 'field',
            label: { en: 'Date of birth', ua: 'Дата народження' },
            value: '14.06.1994'
          },
          {
            id: 'b7',
            kind: 'note',
            label: {
              en: 'I agree to the Terms of Service',
              ua: 'Я погоджуюсь з Умовами користування'
            },
            value: '☐'
          },
          {
            id: 'b8',
            kind: 'button',
            label: { en: 'Submitt', ua: 'Продовжитти' },
            value: '',
            issue: {
              en: '"Submitt" is misspelled. Button copy is the first thing a user reads.',
              ua: '«Продовжитти» написано з помилкою. Текст кнопки — перше, що читає користувач.'
            }
          }
        ]
      },
      explain: {
        en: 'Three bugs: the phone mask lets letters through, the password is visible by default, and the main button is misspelled. None of them blocks sign-up, but all three land in the store reviews on day one.',
        ua: 'Три помилки: маска телефону пропускає літери, пароль видно за замовчуванням, а головна кнопка з одруківкою. Жодна не блокує реєстрацію, але всі три опиняться у відгуках у сторі в перший же день.'
      },
      fx: { ok: { quality: 6, coverage: 3 }, fail: { quality: -5 } }
    },
    {
      type: 'triage',
      id: 's2',
      at: '09:30',
      comp: ['risk', 'analysis'],
      traits: ['I', 'C'],
      text: {
        en: 'Five open bugs from the overnight test run. Order them by severity and priority: what gets a developer first.',
        ua: 'П’ять відкритих багів після нічного прогону. Розстав їх за серйозністю й пріоритетом: що першим піде до розробника.'
      },
      items: [
        {
          id: 'pay',
          title: {
            en: 'Payment fails for one bank’s cards',
            ua: 'Оплата не проходить картками одного банку'
          },
          detail: {
            en: 'Steps: pay with a card from the bank that issues 12% of our cards. Impact: order is not created, money is held for 3 days. Frequency: every attempt.',
            ua: 'Кроки: оплатити карткою банку, на який припадає 12% наших карток. Вплив: замовлення не створюється, гроші заморожені на 3 дні. Частота: кожна спроба.'
          }
        },
        {
          id: 'crash',
          title: { en: 'Crash on order history', ua: 'Краш на історії замовлень' },
          detail: {
            en: 'Steps: open history with more than 50 past orders. Impact: the app closes, no workaround. Frequency: 3% of users, all of them regulars.',
            ua: 'Кроки: відкрити історію з понад 50 замовленнями. Вплив: застосунок закривається, обхідного шляху немає. Частота: 3% користувачів, усі постійні.'
          }
        },
        {
          id: 'map',
          title: { en: 'Courier marker frozen on the map', ua: 'Маркер кур’єра завмирає на мапі' },
          detail: {
            en: 'Steps: track a courier on Android 12. Impact: position does not update; pull-to-refresh fixes it. Frequency: 15% of Android users.',
            ua: 'Кроки: стежити за кур’єром на Android 12. Вплив: позиція не оновлюється; оновлення свайпом допомагає. Частота: 15% користувачів Android.'
          }
        },
        {
          id: 'promo',
          title: {
            en: 'Promo code rejected in lowercase',
            ua: 'Промокод не приймається малими літерами'
          },
          detail: {
            en: 'Steps: type a valid code in lowercase. Impact: "invalid code" error; uppercase works. Frequency: 8% of orders use a code.',
            ua: 'Кроки: ввести чинний код малими літерами. Вплив: помилка «невірний код»; великими працює. Частота: 8% замовлень із кодом.'
          }
        },
        {
          id: 'typo',
          title: { en: 'Typo in the cuisine filter', ua: 'Одруківка у фільтрі кухонь' },
          detail: {
            en: 'Steps: open filters. Impact: "Itallian" instead of "Italian". Frequency: every user who opens filters.',
            ua: 'Кроки: відкрити фільтри. Вплив: «Італйська» замість «Італійська». Частота: кожен, хто відкриває фільтри.'
          }
        }
      ],
      correctOrder: ['pay', 'crash', 'map', 'promo', 'typo'],
      explain: {
        en: 'Lost orders and held money for 12% of cards beat everything. A crash with no workaround outranks a frozen marker that a swipe fixes, even though the marker hits more people. The promo code has a workaround, and the typo is cosmetic.',
        ua: 'Втрачені замовлення й заморожені гроші на 12% карток важливіші за все. Краш без обхідного шляху вищий за завмерлий маркер, який лікується свайпом, хоч маркер і зачіпає більше людей. Промокод має обхідний шлях, а одруківка — косметика.'
      },
      fx: { ok: { quality: 5, team: 2 }, fail: { quality: -5, energy: -4 } }
    },
    {
      type: 'chat',
      id: 's3',
      at: '10:15',
      comp: ['communication', 'analysis'],
      traits: ['S', 'I'],
      messages: [
        {
          from: 'dev',
          text: {
            en: 'Closed LZ-412 (double tip on payment switch). Cannot reproduce, works on my machine. Probably your test device.',
            ua: 'Закрив LZ-412 (подвійні чайові при зміні оплати). Не відтворюється, в мене все працює. Мабуть, твій тестовий телефон.'
          }
        },
        {
          from: 'lead',
          text: {
            en: 'Is 412 fixed or not? I need the list of open blockers by 11:00.',
            ua: '412 полагоджено чи ні? Мені потрібен список відкритих блокерів до 11:00.'
          }
        }
      ],
      prompt: { en: 'What do you write to Maksym?', ua: 'Що пишеш Максиму?' },
      options: [
        {
          text: {
            en: 'Reopen it with the exact setup: build 4.2.118, Android 13, steps 1–3, a 20-second screen recording and the server log line. Offer to show it on your phone in five minutes.',
            ua: 'Перевідкрити з точним описом: збірка 4.2.118, Android 13, кроки 1–3, 20-секундний запис екрана й рядок із серверного лога. Запропонувати показати на своєму телефоні за п’ять хвилин.'
          },
          q: 'best',
          fx: { quality: 5, team: 3 },
          fb: {
            en: 'A developer cannot argue with a recording and a log line, and the offer to show it keeps the conversation about the bug, not about who is right.',
            ua: 'З записом і рядком лога розробник не сперечатиметься, а пропозиція показати тримає розмову про баг, а не про те, хто правий.'
          }
        },
        {
          text: {
            en: 'Ask him to try on a physical device rather than the emulator, since the tip bug may depend on the payment SDK version, and come back to it after lunch.',
            ua: 'Попросити його спробувати на фізичному пристрої замість емулятора, бо баг із чайовими може залежати від версії платіжного SDK, і повернутися до цього після обіду.'
          },
          q: 'ok',
          fx: { energy: -3 },
          fb: {
            en: 'A fair guess, but you handed him the investigation without the evidence. If he tries once and fails, the ticket is closed again by lunch.',
            ua: 'Логічна здогадка, але ти віддав йому розслідування без доказів. Якщо він спробує раз і не відтворить, тікет знову закриють до обіду.'
          }
        },
        {
          text: {
            en: 'Reopen with the comment "Reproduces for me every time, please check properly" and raise the severity to blocker so it cannot be closed again without Oksana.',
            ua: 'Перевідкрити з коментарем «У мене відтворюється щоразу, перевір нормально» і підняти серйозність до блокера, щоб без Оксани його більше не закрили.'
          },
          q: 'bad',
          fx: { team: -8 },
          fb: {
            en: 'Raising severity to win an argument teaches the team that your blockers are political. The next real blocker gets the same eye-roll.',
            ua: 'Піднімати серйозність, щоб виграти суперечку, вчить команду, що твої блокери політичні. Наступний справжній блокер отримає те саме закочування очей.'
          },
          later: {
            after: 2,
            note: {
              en: 'Maksym wrote in the dev channel that QA "inflates severity". Two developers reacted with a thumbs-up.',
              ua: 'Максим написав у каналі розробки, що QA «роздуває серйозність». Двоє розробників поставили лайк.'
            },
            fx: { team: -4 }
          }
        },
        {
          text: {
            en: 'Let it stay closed. If the double tip reaches production, support will report it with real customers and the fix will get priority without a fight.',
            ua: 'Залишити закритим. Якщо подвійні чайові дійдуть до проду, підтримка принесе це з реальними клієнтами, і фікс отримає пріоритет без суперечок.'
          },
          q: 'bad',
          fx: { quality: -8, trust: -4 },
          fb: {
            en: 'You know about a money bug and chose to let customers find it. That is the one thing QA is paid to prevent.',
            ua: 'Ти знаєш про баг із грошима і вирішив дати клієнтам знайти його самим. Це єдине, за що QA платять, щоб не сталося.'
          }
        }
      ],
      principle: {
        en: 'A bug report is evidence, not an opinion.',
        ua: 'Баг-репорт — це докази, а не думка.'
      }
    },
    {
      type: 'queue',
      id: 's4',
      at: '11:00',
      comp: ['process', 'communication'],
      traits: ['S', 'C'],
      text: {
        en: 'Four reports landed while you were in standup. Open them in the order you think is right and decide: reproduce, ask for more, or link as a duplicate.',
        ua: 'Поки ти був на стендапі, прийшло чотири репорти. Відкрий їх у тому порядку, який вважаєш правильним, і вирішуй: відтворювати, допитати чи позначити дублікатом.'
      },
      tickets: [
        {
          id: 't1',
          from: 'support',
          urgency: 3,
          sla: { en: '30 min', ua: '30 хв' },
          subject: {
            en: 'Customers cannot pay by card since morning',
            ua: 'Клієнти з ранку не можуть оплатити карткою'
          },
          body: {
            en: 'Nine chats in an hour: payment fails, money is held. All of them mention the same bank. Is this known? I need something to tell them.',
            ua: 'Дев’ять чатів за годину: оплата не проходить, гроші заморожені. Усі згадують один і той самий банк. Це відоме? Мені треба щось їм відповісти.'
          },
          options: [
            {
              text: {
                en: 'Link it to the open card bug LZ-398, add the nine cases and the bank name to it, and tell Yurii the fix is in today’s release, with a line he can send to customers.',
                ua: 'Зв’язати з відкритим багом LZ-398, додати туди дев’ять кейсів і назву банку, а Юрієві сказати, що фікс у сьогоднішньому релізі, і дати рядок, який він може надіслати клієнтам.'
              },
              q: 'best',
              fx: { team: 4, quality: 2 },
              fb: {
                en: 'One ticket with growing evidence is what a developer needs; nine duplicates are noise. Support got an answer in a sentence, which is what they asked for.',
                ua: 'Один тікет із доказами, що накопичуються, — те, що потрібно розробнику; дев’ять дублікатів — шум. Підтримка отримала відповідь одним реченням, саме про це вона й просила.'
              }
            },
            {
              text: {
                en: 'Create a new high-priority ticket from the support cases so nothing gets lost, and ask Yurii to attach screenshots from each customer when he can.',
                ua: 'Завести новий тікет із високим пріоритетом за кейсами підтримки, щоб нічого не загубилося, і попросити Юрія додати скриншоти від кожного клієнта, коли зможе.'
              },
              q: 'ok',
              fx: { energy: -3 },
              fb: {
                en: 'Nothing is lost, but now two tickets describe one bug and someone will fix only one of them. Yurii still has no answer for the customers.',
                ua: 'Нічого не загубилося, але тепер один баг описано у двох тікетах, і хтось полагодить лише один. Юрій досі не має відповіді для клієнтів.'
              }
            },
            {
              text: {
                en: 'Ask Yurii for exact steps, device models and card types for every case before you log anything, since support reports are usually incomplete.',
                ua: 'Попросити Юрія надати точні кроки, моделі пристроїв і типи карток по кожному кейсу, перш ніж щось заводити, бо репорти підтримки зазвичай неповні.'
              },
              q: 'bad',
              fx: { team: -5, quality: -3 },
              fb: {
                en: 'You already know this bug. Making support collect data you do not need costs them an hour and tells them QA is a wall, not a partner.',
                ua: 'Ти вже знаєш цей баг. Змушувати підтримку збирати непотрібні дані коштує їм годину й каже, що QA — це стіна, а не партнер.'
              }
            }
          ]
        },
        {
          id: 't2',
          from: 'pm',
          urgency: 2,
          sla: { en: 'today', ua: 'сьогодні' },
          subject: { en: 'App is slow', ua: 'Застосунок гальмує' },
          body: {
            en: 'A friend says the app got really slow on his phone after the last update. Can you look into it before the release? Feels like a regression.',
            ua: 'Знайомий каже, що після останнього оновлення застосунок у нього дуже гальмує. Можеш глянути до релізу? Схоже на регресію.'
          },
          options: [
            {
              text: {
                en: 'Reply with a four-line checklist for the friend: phone model, OS version, which screen, and a short video, and say you will reproduce it the moment it arrives.',
                ua: 'Відповісти чеклістом із чотирьох рядків для знайомого: модель телефону, версія ОС, який екран і коротке відео, і сказати, що відтвориш одразу, щойно це прийде.'
              },
              q: 'best',
              fx: { quality: 3, trust: 2 },
              fb: {
                en: '"Slow" is not a bug yet; it is a feeling. Four facts turn it into one you can reproduce, and Kateryna sees that you took it seriously.',
                ua: '«Гальмує» — ще не баг, а відчуття. Чотири факти перетворюють його на те, що можна відтворити, а Катерина бачить, що ти поставився серйозно.'
              }
            },
            {
              text: {
                en: 'Spend an hour running the main screens on your three test devices with a profiler and report back what you see, whether or not it matches the friend.',
                ua: 'Витратити годину й прогнати головні екрани на трьох тестових пристроях із профайлером, а потім відзвітувати, що бачиш, незалежно від того, чи збігається це зі знайомим.'
              },
              q: 'ok',
              fx: { energy: -6, coverage: 2 },
              fb: {
                en: 'Thorough, but you may spend an hour on the wrong phone and the wrong screen. On release day, the hour was the expensive part.',
                ua: 'Ретельно, але ти можеш витратити годину не на той телефон і не на той екран. У день релізу саме година була дорогою.'
              }
            },
            {
              text: {
                en: 'Reply that it cannot be reproduced without steps and close the request, since release day is not the time for vague reports from friends.',
                ua: 'Відповісти, що без кроків відтворити неможливо, і закрити запит, бо день релізу — не час для розмитих репортів від знайомих.'
              },
              q: 'bad',
              fx: { trust: -5, team: -3 },
              fb: {
                en: 'Technically right, and the product manager just learned that bringing you a signal gets a door closed. Next time she will not bring it.',
                ua: 'Формально правильно, і продакт щойно дізналася, що принести тобі сигнал означає зачинені двері. Наступного разу вона його не принесе.'
              }
            }
          ]
        },
        {
          id: 't3',
          from: 'junior',
          urgency: 2,
          sla: { en: '1 h', ua: '1 год' },
          subject: {
            en: 'Order total wrong with a tip',
            ua: 'Неправильна сума замовлення з чайовими'
          },
          body: {
            en: 'Build 4.2.118, Android 13, test phone #2. Add any item, add a 10% tip, switch payment from card to cash: the tip is added twice. Video attached. Can you confirm before I file it?',
            ua: 'Збірка 4.2.118, Android 13, тестовий телефон №2. Додати будь-яку страву, додати 10% чайових, змінити оплату з картки на готівку: чайові додаються двічі. Відео прикріплене. Підтвердиш, перш ніж я заведу тікет?'
          },
          options: [
            {
              text: {
                en: 'Reproduce it on your own device now, confirm in the thread and ask her to file it as major with her video, then link it to LZ-412, which looks like the same bug.',
                ua: 'Відтворити на своєму пристрої зараз, підтвердити у треді й попросити її завести тікет як major зі своїм відео, а потім зв’язати з LZ-412, бо це схоже на той самий баг.'
              },
              q: 'best',
              fx: { quality: 4, team: 3, coverage: 2 },
              fb: {
                en: 'Her report already has everything, so confirmation takes two minutes and gives Maksym a second reproduction. Letting her file it is how juniors become seniors.',
                ua: 'У її репорті вже є все, тож підтвердження займе дві хвилини й дасть Максиму друге відтворення. Дати їй завести тікет самій — так джуніори стають сеньйорами.'
              }
            },
            {
              text: {
                en: 'Forward it straight to Maksym without reproducing; Sofiia’s reports are careful and the video says it all, and you have three other things open.',
                ua: 'Переслати одразу Максиму, не відтворюючи; репорти Софії охайні, відео все показує, а в тебе ще три відкриті справи.'
              },
              q: 'ok',
              fx: { energy: 2, quality: -2 },
              fb: {
                en: 'Probably fine, but "QA did not even check" is the first thing a developer says when a report has a gap. Two minutes buys you the right to insist.',
                ua: 'Мабуть, нормально, але «QA навіть не перевіряв» — перше, що скаже розробник, якщо в репорті буде прогалина. Дві хвилини купують тобі право наполягати.'
              }
            },
            {
              text: {
                en: 'Tell her it is probably a rounding thing in the tip calculation and to put it in the backlog for the next sprint, since the release is today.',
                ua: 'Сказати їй, що це, мабуть, округлення в розрахунку чайових, і хай кладе в беклог на наступний спринт, бо реліз сьогодні.'
              },
              q: 'bad',
              fx: { quality: -7, team: -4 },
              fb: {
                en: 'Customers would be charged twice on release day and you guessed the cause without looking. The junior just watched you do it.',
                ua: 'У день релізу клієнтам двічі списали б гроші, а ти вгадував причину, навіть не глянувши. Джуніорка щойно це бачила.'
              }
            }
          ]
        },
        {
          id: 't4',
          from: { en: 'Store review', ua: 'Відгук у сторі' },
          urgency: 1,
          sla: { en: 'this week', ua: 'цього тижня' },
          subject: {
            en: '1 star: "Garbage app, deleted it"',
            ua: '1 зірка: «Сміття, а не застосунок, видалив»'
          },
          body: {
            en: 'Review posted yesterday from an Android device. No details, no order number. Support tagged you because it mentions "crashes every time".',
            ua: 'Відгук учора з Android-пристрою. Без деталей і номера замовлення. Підтримка позначила тебе, бо там є «вилітає щоразу».'
          },
          options: [
            {
              text: {
                en: 'Check yesterday’s Android crash logs for a spike that matches, note it on the history-crash ticket if it does, and ask support to reply asking for a device model.',
                ua: 'Переглянути вчорашні Android-логи крашів на збіг зі сплеском, за збігу дописати в тікет про краш історії, а підтримку попросити відповісти й спитати модель пристрою.'
              },
              q: 'best',
              fx: { quality: 2, coverage: 2 },
              fb: {
                en: 'A one-star review is a signal with the details missing. Crash logs are where the details live, and a reply might bring back the customer.',
                ua: 'Відгук на одну зірку — сигнал без деталей. Деталі живуть у логах крашів, а відповідь може повернути клієнта.'
              }
            },
            {
              text: {
                en: 'Leave it for now; one angry review without steps is not something you can act on, and the release needs every minute you have today.',
                ua: 'Поки що залишити; один злий відгук без кроків — не те, з чим можна працювати, а релізу сьогодні потрібна кожна твоя хвилина.'
              },
              q: 'ok',
              fx: { energy: 2 },
              fb: {
                en: 'Reasonable on release day, but the review stays unanswered in the store, where the next thousand users read it before they install.',
                ua: 'У день релізу логічно, але відгук так і висить без відповіді в сторі, де наступна тисяча користувачів прочитає його перед встановленням.'
              }
            },
            {
              text: {
                en: 'File a blocker ticket titled "App crashes every time" with the review text as the description, so that the developers take it seriously.',
                ua: 'Завести тікет-блокер «Застосунок вилітає щоразу» з текстом відгуку замість опису, щоб розробники поставилися до нього серйозно.'
              },
              q: 'bad',
              fx: { team: -5, quality: -2 },
              fb: {
                en: 'A blocker nobody can reproduce burns an hour of a developer’s release day and your credibility along with it.',
                ua: 'Блокер, який ніхто не може відтворити, спалює годину релізного дня розробника й твою репутацію разом із нею.'
              }
            }
          ]
        }
      ]
    },
    {
      type: 'numeric',
      id: 's5',
      at: '12:00',
      comp: ['analysis', 'process'],
      traits: ['I', 'C'],
      text: {
        en: 'The automated regression run has just finished. Oksana needs the failure rate for the release checklist; the gate is 2%.',
        ua: 'Автоматичний прогін регресії щойно завершився. Оксані потрібен відсоток падінь для релізного чекліста; поріг — 2%.'
      },
      data: [
        { label: { en: 'Tests in the run', ua: 'Тестів у прогоні' }, value: '200' },
        { label: { en: 'Passed', ua: 'Пройшло' }, value: '184' },
        { label: { en: 'Release gate, failed', ua: 'Поріг релізу, падінь' }, value: '≤ 2%' }
      ],
      question: {
        en: 'What share of the tests failed, in %?',
        ua: 'Яка частка тестів упала, у %?'
      },
      answer: 8,
      tolerance: 0.05,
      unit: { en: '%', ua: '%' },
      hint: {
        en: 'Failed is what is left after the passes; divide it by the whole run.',
        ua: 'Падіння — це те, що лишилося після успішних; поділи на весь прогін.'
      },
      explain: {
        en: '200 − 184 = 16 failed tests. 16 ÷ 200 = 0.08, so 8% failed, four times the 2% gate. Before anyone panics, check how many of the 16 are one broken fixture.',
        ua: '200 − 184 = 16 тестів упало. 16 ÷ 200 = 0,08, тобто 8% падінь, учетверо більше за поріг у 2%. Перш ніж усі запанікують, перевір, скільки з 16 — одна зламана фікстура.'
      },
      fx: { ok: { coverage: 5, quality: 2 }, fail: { coverage: -4 } }
    },
    {
      type: 'chat',
      id: 's6',
      at: '13:30',
      comp: ['risk', 'communication'],
      traits: ['E', 'S'],
      messages: [
        {
          from: 'pm',
          text: {
            en: 'Marketing has the launch post scheduled for 19:00 and the partner restaurants were promised today. Can we skip the manual regression just this once? The automated run mostly passed.',
            ua: 'Маркетинг запланував пост про запуск на 19:00, ресторанам-партнерам обіцяли сьогодні. Можемо цього разу пропустити ручну регресію? Автоматика ж майже пройшла.'
          }
        },
        {
          from: 'lead',
          text: {
            en: 'What gets tested is your call. I need a yes or a no with reasons by 14:00.',
            ua: 'Що тестувати — твоє рішення. Мені потрібне «так» або «ні» з причинами до 14:00.'
          }
        }
      ],
      prompt: { en: 'What do you answer Kateryna?', ua: 'Що відповідаєш Катерині?' },
      options: [
        {
          text: {
            en: 'Offer a risk-based cut: the 40 critical-path cases (login, ordering, payment, courier tracking) in two hours, cosmetic cases skipped, and the skipped list written into the release note.',
            ua: 'Запропонувати скорочення за ризиком: 40 кейсів критичного шляху (вхід, замовлення, оплата, трекінг кур’єра) за дві години, косметику пропустити, а список пропущеного записати в реліз-ноут.'
          },
          q: 'best',
          fx: { quality: 4, trust: 4, coverage: 2 },
          fb: {
            en: 'She gets today, you keep the paths where bugs cost money, and the note makes the trade visible instead of silent. That is what "risk-based" means in practice.',
            ua: 'Вона отримує сьогодні, ти зберігаєш шляхи, де баги коштують грошей, а нотатка робить компроміс видимим, а не мовчазним. Саме це й означає «за ризиком» на практиці.'
          }
        },
        {
          text: {
            en: 'Agree to skip the manual run, but only with a staged rollout to 10% of users tonight and a monitoring shift until morning, with the full suite run tomorrow.',
            ua: 'Погодитися пропустити ручний прогін, але лише з поетапним викатом на 10% користувачів сьогодні ввечері й чергуванням на моніторингу до ранку, а повний набір прогнати завтра.'
          },
          q: 'ok',
          fx: { quality: -2, trust: 2, energy: -6 },
          fb: {
            en: 'A real safety net, and 10% of customers are still your testers tonight. It works when monitoring is good and someone is awake.',
            ua: 'Справжня страховка, але 10% клієнтів усе ж стають твоїми тестувальниками. Працює, коли моніторинг хороший і хтось не спить.'
          }
        },
        {
          text: {
            en: 'Say no: regression is the process and the process exists for a reason, so the release moves to tomorrow and marketing can reschedule the post.',
            ua: 'Сказати «ні»: регресія — це процес, а процес існує не просто так, тож реліз переноситься на завтра, а маркетинг хай переносить пост.'
          },
          q: 'bad',
          fx: { trust: -6, team: -3 },
          fb: {
            en: 'Process is your tool, not your argument. Kateryna hears that QA cannot tell her which tests matter, which is the one thing she needed from you.',
            ua: 'Процес — твій інструмент, а не аргумент. Катерина чує, що QA не може сказати, які тести важливі, а це єдине, що їй від тебе було потрібно.'
          }
        },
        {
          text: {
            en: 'Agree, it is her product and her call; you will test the release on production tonight after it ships and hotfix whatever comes up.',
            ua: 'Погодитися: це її продукт і її рішення; протестуєш реліз на проді сьогодні ввечері після викату, а що вилізе, полагодите хотфіксом.'
          },
          q: 'bad',
          fx: { quality: -8, trust: -3 },
          fb: {
            en: 'Testing on production with the launch post live is testing on customers. "Her call" does not move the blame when the double tip hits a thousand orders.',
            ua: 'Тестувати на проді під час живого запуску — це тестувати на клієнтах. «Її рішення» не переносить провину, коли подвійні чайові вдарять по тисячі замовлень.'
          }
        }
      ],
      principle: {
        en: 'Do not defend the process. Name the risk and the price of skipping it.',
        ua: 'Не захищай процес. Назви ризик і ціну його пропуску.'
      }
    },
    {
      type: 'choice',
      id: 's7',
      at: '14:30',
      comp: ['risk', 'process'],
      traits: ['E', 'I'],
      dilemma: true,
      text: {
        en: 'Regression is done. The card payment bug is fixed and verified. Still open: the history crash (3% of users, no workaround, fix estimated at two days), the lowercase promo code and the filter typo. The build must go to the store by 15:00 to be live tomorrow.',
        ua: 'Регресію завершено. Баг з оплатою карткою полагоджено й перевірено. Відкриті: краш історії (3% користувачів, без обхідного шляху, фікс — орієнтовно два дні), промокод малими літерами й одруківка у фільтрі. Збірка має піти в стор до 15:00, щоб завтра бути доступною.'
      },
      prompt: { en: 'What is your recommendation to Oksana?', ua: 'Яка твоя рекомендація Оксані?' },
      options: [
        {
          text: {
            en: 'Go, with the crash listed as a known issue in the release note, a hotfix slot booked for Thursday, and Oksana’s name next to "risk accepted" in the sign-off.',
            ua: 'Go: краш внести як відому проблему в реліз-ноут, забронювати слот під хотфікс на четвер, а в сайн-офі поруч із «ризик прийнято» поставити ім’я Оксани.'
          },
          q: 'best',
          fx: { quality: 3, trust: 5 },
          fb: {
            en: 'The risk is small, named and owned by someone with the authority to own it. QA’s job is to make the trade visible, not to be the person who says no.',
            ua: 'Ризик малий, названий і має власника з повноваженнями. Завдання QA — зробити компроміс видимим, а не бути тим, хто каже «ні».'
          }
        },
        {
          text: {
            en: 'No-go until the crash is fixed: two days of delay cost less than a wave of one-star reviews from the 3% who order most, and the partners get a firm Thursday date.',
            ua: 'No-go, поки не полагоджено краш: два дні затримки дешевші за хвилю відгуків на одну зірку від 3%, які замовляють найбільше, а партнери отримують тверду дату — четвер.'
          },
          q: 'best',
          fx: { quality: 5, trust: -2 },
          fb: {
            en: 'Defensible: the 3% are the regulars, and a crash with no workaround is exactly what they write reviews about. You pay in trust with marketing, and you say so with a date.',
            ua: 'Обґрунтовано: ці 3% — постійні клієнти, а краш без обхідного шляху — саме те, про що вони пишуть відгуки. Платиш довірою маркетингу, зате називаєш дату.'
          }
        },
        {
          text: {
            en: 'Go, and leave the unfixed bugs out of the release note; nobody reads it, and listing known issues only invites awkward questions from the partners.',
            ua: 'Go, а непофікшені баги в реліз-ноут не вносити: його ніхто не читає, а список відомих проблем лише викличе незручні запитання від партнерів.'
          },
          q: 'bad',
          fx: { trust: -8, quality: -3 },
          fb: {
            en: 'Known issues that are not written down become surprises with your name on them. The note is not for partners; it is for the person on call at 02:00.',
            ua: 'Відомі проблеми, яких не записано, стають сюрпризами з твоїм іменем. Реліз-ноут не для партнерів, а для того, хто чергує о 02:00.'
          },
          later: {
            after: 2,
            note: {
              en: 'Oksana found the crash ticket while triaging a support escalation and asks why it was not in the release note.',
              ua: 'Оксана натрапила на тікет про краш, розбираючи ескалацію підтримки, і питає, чому його не було в реліз-ноуті.'
            },
            fx: { trust: -5 }
          }
        },
        {
          text: {
            en: 'Decline to recommend: QA reports the state, the go/no-go belongs to the product manager and the release manager, so send them the bug list and step back.',
            ua: 'Не давати рекомендації: QA звітує про стан, а go/no-go — справа продакта й реліз-менеджерки, тож надіслати їм список багів і відійти вбік.'
          },
          q: 'bad',
          fx: { trust: -5, team: -3 },
          fb: {
            en: 'A list without a recommendation moves the decision to people with less information than you. They asked for your judgement, not your spreadsheet.',
            ua: 'Список без рекомендації передає рішення людям, у яких менше інформації, ніж у тебе. Вони просили твою оцінку, а не твою таблицю.'
          }
        }
      ],
      principle: {
        en: 'QA does not block releases. QA makes the risk impossible to ignore.',
        ua: 'QA не блокує релізи. QA робить ризик неможливим для ігнорування.'
      }
    },
    {
      type: 'spot',
      id: 's8',
      at: '15:30',
      comp: ['attention', 'analysis'],
      traits: ['C', 'I'],
      text: {
        en: 'While the store reviews the build, Sofiia sends the checkout screen from the next build. It has 3 bugs. Tap each one.',
        ua: 'Поки стор перевіряє збірку, Софія надсилає екран оформлення з наступної збірки. На ньому 3 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'card',
        title: { en: 'Your order — build 4.3.002', ua: 'Ваше замовлення — збірка 4.3.002' },
        blocks: [
          {
            id: 'c1',
            kind: 'heading',
            label: { en: 'Order summary', ua: 'Підсумок замовлення' },
            value: ''
          },
          {
            id: 'c2',
            kind: 'line',
            label: { en: 'Margherita pizza × 2', ua: 'Піца «Маргарита» × 2' },
            value: '2 × 240 = 480'
          },
          {
            id: 'c3',
            kind: 'line',
            label: { en: 'Lemonade 0.5 l × 1', ua: 'Лимонад 0,5 л × 1' },
            value: '65'
          },
          {
            id: 'c4',
            kind: 'note',
            label: { en: 'Free delivery on orders over 400', ua: 'Безкоштовна доставка від 400' },
            value: '✓'
          },
          {
            id: 'c5',
            kind: 'line',
            label: { en: 'Delivery', ua: 'Доставка' },
            value: '49',
            issue: {
              en: 'Food comes to 545, above the 400 free-delivery threshold, yet delivery is charged.',
              ua: 'Страви разом — 545, це більше за поріг 400 для безкоштовної доставки, а доставку все одно нараховано.'
            }
          },
          {
            id: 'c6',
            kind: 'total',
            label: { en: 'Total', ua: 'Разом' },
            value: '584',
            issue: {
              en: '480 + 65 + 49 = 594, not 584. The total does not add up even with delivery charged.',
              ua: '480 + 65 + 49 = 594, а не 584. Сума не сходиться навіть із платною доставкою.'
            }
          },
          {
            id: 'c7',
            kind: 'field',
            label: { en: 'Delivery time', ua: 'Час доставки' },
            value: '24:15',
            issue: {
              en: 'There is no 24:15. The time picker lets an impossible value through.',
              ua: 'Часу 24:15 не існує. Вибір часу пропускає неможливе значення.'
            }
          },
          {
            id: 'c8',
            kind: 'field',
            label: { en: 'Phone', ua: 'Телефон' },
            value: '+380 97 123 45 67'
          },
          { id: 'c9', kind: 'button', label: { en: 'Pay', ua: 'Сплатити' }, value: '' }
        ]
      },
      explain: {
        en: 'Delivery is charged on a 545 order although the rule says free over 400; the total shows 584 where 480 + 65 + 49 = 594; and 24:15 is not a time. Two of the three are money bugs, which is why checkout gets tested twice.',
        ua: 'Доставку нараховано на замовлення 545, хоча правило каже «безкоштовно від 400»; разом показано 584, хоча 480 + 65 + 49 = 594; а 24:15 — не час. Дві з трьох помилок — про гроші, тому екран оплати тестують двічі.'
      },
      fx: { ok: { quality: 6, coverage: 4 }, fail: { quality: -5 } }
    },
    {
      type: 'choice',
      id: 's9',
      at: '16:30',
      comp: ['communication', 'process'],
      traits: ['C', 'S'],
      text: {
        en: 'Sofiia’s double-tip bug is confirmed and LZ-412 is reopened. Maksym asks for "a proper report this time". Four drafts are on your screen. Which one do you send?',
        ua: 'Баг Софії з подвійними чайовими підтверджено, LZ-412 перевідкрито. Максим просить «цього разу нормальний репорт». На екрані чотири чернетки. Яку надсилаєш?'
      },
      options: [
        {
          text: {
            en: 'Title: "Tip charged twice after switching card to cash on checkout, 4.2.118, Android 13". Steps 1–3, expected vs actual, the 20-second video, the log request id.',
            ua: 'Назва: «Чайові списано двічі після зміни картки на готівку на оформленні, 4.2.118, Android 13». Кроки 1–3, очікувано/фактично, 20-секундне відео, id запиту з лога.'
          },
          q: 'best',
          fx: { quality: 5, team: 4 },
          fb: {
            en: 'A developer can reproduce it from the title alone and verify the fix from "expected". The log id saves the hour of searching that usually comes first.',
            ua: 'Розробник відтворить баг уже з назви й перевірить фікс за «очікувано». Id з лога заощаджує годину пошуків, з якої зазвичай усе починається.'
          }
        },
        {
          text: {
            en: 'Title: "Tip added twice". Build 4.2.118 and the three steps in the description, severity major, no video, since the steps are clear enough to reproduce.',
            ua: 'Назва: «Чайові додаються двічі». В описі збірка 4.2.118 і три кроки, серйозність major, без відео, бо кроків достатньо, щоб відтворити.'
          },
          q: 'ok',
          fx: { quality: 1 },
          fb: {
            en: 'Reproducible, but without expected vs actual Maksym decides what "fixed" means, and without the video the next "works on my machine" is one reply away.',
            ua: 'Відтворити можна, але без «очікувано/фактично» Максим сам вирішує, що таке «полагоджено», а без відео наступне «в мене працює» — за одну відповідь.'
          }
        },
        {
          text: {
            en: 'Title: "Checkout is broken again, see video". Severity blocker, assigned to Maksym, with the video attached and a note that this was already reported once.',
            ua: 'Назва: «Оформлення знову зламане, див. відео». Серйозність blocker, призначено Максиму, відео прикріплене, і примітка, що це вже репортили раніше.'
          },
          q: 'bad',
          fx: { team: -6, quality: -2 },
          fb: {
            en: 'The title says nothing, the severity is an argument and the note is a jab. He will watch the video after he has stopped being annoyed, which is tomorrow.',
            ua: 'Назва ні про що, серйозність — аргумент у суперечці, а примітка — шпилька. Відео він подивиться, коли перестане дратуватися, тобто завтра.'
          }
        },
        {
          text: {
            en: 'No ticket: describe it to Maksym in a direct message with the video. He is fast, tickets slow everyone down, and the release is already in the store queue.',
            ua: 'Без тікета: описати Максиму в особистих повідомленнях разом із відео. Він швидкий, тікети всіх гальмують, а реліз уже в черзі стору.'
          },
          q: 'bad',
          fx: { quality: -5, coverage: -3 },
          fb: {
            en: 'A bug in a DM has no status, no owner once he is on holiday and no place in the next regression. In two weeks nobody remembers it existed.',
            ua: 'Баг в особистих не має статусу, власника, коли він у відпустці, і місця в наступній регресії. За два тижні ніхто не згадає, що він був.'
          }
        }
      ],
      principle: {
        en: 'Write the report for a developer at 02:00 who has never seen your screen.',
        ua: 'Пиши репорт для розробника о 02:00, який ніколи не бачив твого екрана.'
      }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: {
          en: 'You would be trusted with the release button',
          ua: 'Тобі довірили б кнопку релізу'
        },
        text: {
          en: 'You turned every bug into evidence, ranked risk by money rather than noise, and said what you would ship with your name on it.',
          ua: 'Ти перетворював кожен баг на докази, ранжував ризики за грошима, а не за шумом, і казав, що випустив би під своїм іменем.'
        }
      },
      {
        min: 0.6,
        title: {
          en: 'Solid tester, still learning to negotiate',
          ua: 'Впевнений тестувальник, який ще вчиться домовлятися'
        },
        text: {
          en: 'Your eye for bugs is there; the misses were conversations, where process became the argument instead of risk.',
          ua: 'Око на баги є; промахи були в розмовах, де аргументом ставав процес, а не ризик.'
        }
      },
      {
        min: 0.4,
        title: {
          en: 'You find bugs, people do not yet hear you',
          ua: 'Ти знаходиш баги, але тебе ще не чують'
        },
        text: {
          en: 'Severity was often a weapon and a report was often a feeling. Re-read the feedback on the two chats with Maksym and Kateryna.',
          ua: 'Серйозність часто була зброєю, а репорт — відчуттям. Перечитай фідбек до двох розмов із Максимом і Катериною.'
        }
      },
      {
        min: 0,
        title: {
          en: 'This release day would have shipped the double tip',
          ua: 'Цей реліз випустив би подвійні чайові'
        },
        text: {
          en: 'Many choices optimised for being quick or being liked. The job is slower and less popular: make the risk impossible to miss.',
          ua: 'Багато рішень були про швидкість або про те, щоб сподобатися. Робота ж повільніша й менш популярна: зробити ризик неможливим для ігнорування.'
        }
      }
    ],
    reality: [
      {
        en: 'Roughly a third of the day is writing: steps, expected results, test cases nobody reads until something breaks.',
        ua: 'Приблизно третина дня — писання: кроки, очікувані результати, тест-кейси, які ніхто не читає, поки щось не зламається.'
      },
      {
        en: 'You run the same 120 regression cases before every release, about twice a month, and most of them pass every time.',
        ua: 'Перед кожним релізом, приблизно двічі на місяць, ти проганяєш ті самі 120 кейсів регресії, і більшість проходить щоразу.'
      },
      {
        en: 'Two or three times a week a developer tells you a bug is not a bug. Proving it politely is half the craft.',
        ua: 'Два-три рази на тиждень розробник каже, що баг — не баг. Ввічливо довести протилежне — половина ремесла.'
      }
    ]
  }
};
